import { Link, useNavigate, useLocation } from "react-router-dom";
import "../navbar/nav.css";
import SignIn from "../login/SignIn";
import SignUp from "../login/SignUp";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/reducers";
import { toast } from "react-toastify";
import LogoutIcon from "@mui/icons-material/Logout";
import { useEffect, useRef, useState } from "react";
import { Typography } from "@mui/material";
import { decryptAndRetrieveData } from "../login/encript-decript";
import { useCookies } from "react-cookie";
import Sidebar from "../Sidebar";
import MenuButton from "../MenuButton";

function Navbar() {
  const user = decryptAndRetrieveData("isAuth", "123456789");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleNavToggle = () => {
    setIsNavOpen((prev) => !prev);
  };
  const handleLinkClick = () => {
    setIsNavOpen(false); // Close navbar on link click
  };

  const logoutComponent = () => {
    dispatch(logout());

    // Ensure correct cookie removal
    // Clear localStorage
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("isAuth");
    localStorage.removeItem("userName");
    toast.success("Logout successfully!");
    navigate("/");
    setIsNavOpen(false);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 991);

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loginuser = decryptAndRetrieveData("user", "123456789");

  const dummyImage =
    "https://www.kindpng.com/picc/m/22-223965_no-profile-picture-icon-circle-member-icon-png.png";

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light w-100" id="mainNav">
        <div className="container-fluid ">
          <div>
            <Sidebar logoutComponent={logoutComponent} />
          </div>
          <Link
            to={user ? "/dashboard" : "/"}
            className="navbar-brand d-flex flex-column"
            id="logoRS-nav-link"
          >
            {/* <h4 className="h4 m-0">CALIFORNIA FOREST</h4>
            <h4 className="h4 m-0">INDUSTRY DIRECTORY</h4> */}
            <img className="logo-w" src={"/img/CFID-logo.png"} alt="" />
          </Link>

          <button
             className={`navbar-toggler ${isNavOpen ? "" : "collapsed"}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
            style={{border : 'none'}}
            onClick={handleNavToggle}
          >
            <span> <i className="fa fa-bars ms-1" style={{ color: 'black' }} /></span>
          </button>

          <div className={`collapse navbar-collapse ma-1 ${isNavOpen ? "show" : ""}`} id="navbarResponsive">
            <ul className="navbar-nav py-4 py-lg-0">
              
              {user && (
                <>
                  <li className={`nav-item ${location.pathname === "/add-company" ? "active" : ""}`}>
                    <Link to="/add-company" onClick={handleLinkClick} className="nav-link">Add Company</Link>
                  </li>
                  <li className={`nav-item ${location.pathname === "/my-company" ? "active" : ""}`}>
                    <Link to="/my-company" onClick={handleLinkClick} className="nav-link">My Company</Link>
                  </li>
                </>
              )}
               {(isMobile) &&
                <li className="d-flex" style={{ alignItems: 'center', justifyContent: 'center' }}>
                  <MenuButton handleLinkClick={handleLinkClick} />
                </li>}
                <li className={`nav-item ${location.pathname === "/contactus" ? "active" : ""}`}>
                <Link to="/contactus" onClick={handleLinkClick} className="nav-link">Contact Us</Link>
              </li> 
            </ul>

            <div className="d-flex button-nav">
              {!user ? (
                <>
                  
                  <SignIn style={{ margin: "1em" }} />
                  <SignUp style={{ margin: "1em" }} />
                </>
              ) : (
                <div className="nav-links-other nav-profile">
                  <ul className="navbar-nav">
                    <li className="dropdown" ref={dropdownRef}>
                      <a
                        onClick={() => setIsLoggedIn(!isLoggedIn)}
                        className="nav-link"
                        // href=""
                        id="navbarDropdown"
                        role="button"
                        aria-expanded={isLoggedIn}
                      >
                        {localStorage.getItem("user") ? (
                          <Typography
                            sx={{
                              border: "2px solid rgb(165, 191, 69);",
                              padding: "0.5em",
                              borderRadius: "50%",
                              backgroundColor: "rgb(165, 191, 69);",
                              color: "white",
                              width: "45px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {loginuser}
                          </Typography>
                        ) : (
                          <img src={dummyImage} alt="Profile" height={"45px"} />
                        )}
                      </a>

                      {isLoggedIn && (
                        <ul
                          className={`dropdown-menu dropdown-menu-end${isLoggedIn ? " show" : ""}`}
                          aria-labelledby="navbarDropdown"
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: "0",
                            zIndex: "1050",
                            height: "auto",
                          }}
                        >
                          <li>
                            <Link
                              to="/"
                              className="dropdown-item d-flex align-items-center"
                              onClick={logoutComponent}
                            >
                              <LogoutIcon style={{ marginRight: "10px" }} /> Logout
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
